import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is correctly defined
import { useNavigate } from 'react-router-dom';

const StockOut = () => {
    const [amount, setPCS] = useState('');
    const [transactionType, setTransactionType] = useState('OUTGOING'); // Default is OUTGOING
    const [description, setDescription] = useState('');
    const [statusMessage, setStatusMessage] = useState('');
    const navigate = useNavigate();

    const handlePCSChange = (event) => {
        setPCS(event.target.value);
    };

    const handleTransactionTypeChange = (event) => {
        setTransactionType(event.target.value);
    };

    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        
        // Validation
        if (!amount || !description) {
            setStatusMessage("Please fill in all fields.");
            return;
        }

        const transactionData = {
            staff_id: 1,  // You can update the staff ID dynamically if needed
            amount: parseFloat(amount),
            transaction_type: transactionType.toUpperCase(),
            description: description,
        };

        // POST request to the backend API
        fetch(`${BASE_URL}salesstocks/transaction`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(transactionData),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setStatusMessage(data.message); // Success message
                    setTimeout(() => {
                        navigate('/SalesStockList'); // Navigate back after success (or to any other page)
                    }, 2000);
                } else {
                    setStatusMessage('Transaction failed: ' + data.message);
                }
            })
            .catch((error) => {
                setStatusMessage('Error: ' + error.message);
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Stock Out</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Add a New Stock-Out Transaction</h4>
                            </div>
                            <div className="card-body">
                                {/* Stock Out Form */}
                                <form onSubmit={handleSubmit}>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label htmlFor="amount" className="form-label">PCS</label>
                                            <input
                                                type="number"
                                                id="amount"
                                                className="form-control"
                                                value={amount}
                                                onChange={handlePCSChange}
                                                placeholder="Enter amount"
                                                required
                                            />
                                        </div>

                                        {/* <div className="col-md-6">
                                            <label htmlFor="transactionType" className="form-label">Transaction Type</label>
                                            <select
                                                id="transactionType"
                                                className="form-control"
                                                value={transactionType}
                                                onChange={handleTransactionTypeChange}
                                                disabled // Transaction Type should be fixed for stock out
                                            >
                                                <option value="OUTGOING">Outgoing</option>
                                                <option value="INCOMING">Incoming</option>
                                            </select>
                                        </div> */}
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <label htmlFor="description" className="form-label">Description</label>
                                            <textarea
                                                id="description"
                                                className="form-control"
                                                value={description}
                                                onChange={handleDescriptionChange}
                                                placeholder="Enter description"
                                                required
                                            />
                                        </div>
                                    </div>

                                    {statusMessage && (
                                        <div className="alert alert-info">
                                            {statusMessage}
                                        </div>
                                    )}

                                    <button type="submit" className="btn btn-danger">Submit Stock Out</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default StockOut;
